import type { SiteConfigs } from './types';

import { URL } from '../../constants';
import { httpApiService } from '../../utils/create-http-api-service';
import { defaultRequestService } from '../../utils/default-request-service';

// ---

export const changeSiteConfig = <T extends keyof SiteConfigs>(
  name: T,
  value: SiteConfigs[T],
) => {
  type AdapterProps = { request: Record<T, SiteConfigs[T]> };

  return defaultRequestService<AdapterProps>(URL.SITE_CONFIGS, httpApiService.post, {
    requestData: { [name]: value } as AdapterProps['request'],
  });
};

export const fetchSiteConfigs = () => {
  type AdapterProps = { response: SiteConfigs };

  return defaultRequestService<AdapterProps>(URL.SITE_CONFIGS, httpApiService.get);
};
